// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Wrapper for the video and content */
.wrapper {
    position: relative;
    width: 100%;
    height: 100%;
}

/* Video container styling */
.oxy-video-container {
    position: relative;
}

/* Video background styling */
video {
    position: fixed;
    top: 50%;
    left: 50%;
    min-width: 100%;
    min-height: 100%;
    width: auto;
    height: auto;
    transform: translate(-50%, -50%);
    z-index: -1;
}

/* Overlay on the video */
.oxy-video-overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.53);
}


/* Main container for the content */
.maincontainer {
    position: relative;
    z-index: 1;
    padding: 20px;
}

/* Header container with logo */
/*#header {*/
/*    padding: 20px 0;*/
/*}*/

.logo img {
    max-width: 100%;
}

#dashboard-login {
    display: block;
        /* Simple block display */
    width: 100%;             /* Take full width */
    text-align: center;
        /* Center align text content */
}

/* Login box styling */
.login-box {
    background-color: rgba(255, 255, 255, 0.8);  /* Slightly transparent background */
    padding: 40px;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    width: 100%;
    max-width: 400px;  /* Max width for the login box */
    margin: 0 auto;  /* Center the login box if necessary */
}

/* Login box container */
.login-box {
    background-color: white;
    padding: 40px;
    border-radius: 8px;
}

/* Form elements styling */
.form-element {
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
}

.form-element label {
    color: #333;
    font-weight: 500;
    text-align: left;
    width: 100%;
}

.form-element input {
    width: 100%;
}

input[type='email'],
input[type='password'] {
    width: 100%;
    padding: 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
}

/* Checkbox styling */
.checkbox-holder {
    display: flex;
    align-items: center;
}

.input_checkbox {
    margin-right: 10px;
}

.input_checkbox_label {
    font-size: 14px;
    color: #333;
}

/* Login button */
.button.Login-btn {
    background-color: #373C5F;
    color: white;
    padding: 15px 25px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    width: 100%;
}

.button.Login-btn:hover {
    background-color: #373C5F;
}

/* Styling for the main container */
.maincontainer {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
        /* Use min-height instead of fixed height */
    width: 100%;    /* Ensure full width */
    flex-direction: column; /* Stack items vertically */
    position: relative;
        /* Allow relative positioning */
        padding: 20px;
}

/* Styling for the dashboard heading */
.login-box-heading {
    text-align: center;
    color: #fff;
    width: 100%; /* Ensure full width */
    font-size: 2.5rem;
        /* Use rem for better scaling */
        margin-bottom: 30px;
        /* Add proper spacing */
        font-weight: 600;
        margin-top: 60px;
        /* Add top margin for better spacing */
}

/* Styling for the login box */
.login-box {
    background-color: white;
    padding: 40px;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    width: 100%;
    max-width: 400px;
    margin: 0 auto 200px auto;
}


/* Responsive styles */
/* Large Desktop (1200px and above) */
@media (min-width: 1200px) {
    .maincontainer {
        padding: 40px;
    }

    .login-box-heading {
        font-size: 3rem;
        margin-bottom: 40px;
        margin-top: 80px;
    }

    .login-box {
        padding: 50px;
        max-width: 450px;
    }
}

/* Desktop and Large Tablets (992px to 1199px) */
@media (min-width: 992px) and (max-width: 1199px) {
    .maincontainer {
        padding: 30px;
    }

    .login-box-heading {
        font-size: 2.8rem;
        margin-bottom: 35px;
        margin-top: 70px;
    }

    .login-box {
        padding: 45px;
        max-width: 420px;
    }
}

/* Tablets (768px to 991px) */
@media (min-width: 768px) and (max-width: 991px) {
    .maincontainer {
        padding: 25px;
    }

    .login-box-heading {
        font-size: 2.5rem;
        margin-bottom: 30px;
        margin-top: 60px;
    }

    .login-box {
        padding: 40px;
        max-width: 400px;
    }
}

/* Mobile Large (576px to 767px) */
@media (min-width: 576px) and (max-width: 767px) {
    .maincontainer {
        padding: 20px;
        min-height: 100vh;
    }

    .login-box-heading {
        font-size: 2.2rem;
        margin-bottom: 25px;
        margin-top: 40px;
    }

    .login-box {
        padding: 30px;
        max-width: 350px;
    }

    .form-element {
        margin-bottom: 18px;
    }
}

/* Mobile (480px to 575px) */
@media (min-width: 480px) and (max-width: 575px) {
    .maincontainer {
        padding: 15px;
        min-height: 100vh;
    }

    .login-box-heading {
        font-size: 1.9rem;
        margin-bottom: 20px;
        margin-top: 30px;
    }

    .login-box {
        padding: 25px;
        max-width: 320px;
    }

    .form-element {
        margin-bottom: 16px;
    }

    input[type='email'],
    input[type='password'] {
        padding: 10px;
        font-size: 16px;
        /* Prevent zoom on iOS */
    }
}

/* Small Mobile (320px to 479px) */
@media (min-width: 320px) and (max-width: 479px) {
    .maincontainer {
        padding: 10px;
        min-height: 100vh;
    }

    .login-box-heading {
        font-size: 1.6rem;
        margin-bottom: 15px;
        margin-top: 20px;
        line-height: 1.3;
    }
    .login-box {
        padding: 20px;
        max-width: 300px;
            margin-bottom: 10px;
        }
        
        .form-element {
            margin-bottom: 15px;
        }
        
        input[type='email'],
        input[type='password'] {
            padding: 10px;
            font-size: 16px;
            /* Prevent zoom on iOS */
        }
        
        .button.Login-btn {
            padding: 12px 20px;
            font-size: 16px;
        }
        
        .input_checkbox_label {
            font-size: 13px;
        }
        }
        
        /* Extra Small Mobile (below 320px) */
        @media (max-width: 319px) {
            .maincontainer {
                padding: 8px;
                min-height: 100vh;
            }
        
            .login-box-heading {
                font-size: 1.4rem;
                margin-bottom: 12px;
                margin-top: 15px;
                line-height: 1.2;
            }
        
            .login-box {
                padding: 15px;
                max-width: 280px;
            }
        
            .form-element {
                margin-bottom: 12px;
            }
            
            .form-element label {
                font-size: 14px;
            }
        
            input[type='email'],
            input[type='password'] {
                padding: 8px;
                font-size: 16px;
    }
    
    .button.Login-btn {
        padding: 10px 15px;
            font-size: 14px;
        }
        
        .input_checkbox_label {
            font-size: 12px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/login.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA,4BAA4B;AAC5B;IACI,kBAAkB;AACtB;;AAEA,6BAA6B;AAC7B;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,WAAW;AACf;;AAEA,yBAAyB;AACzB;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR,qCAAqC;AACzC;;;AAGA,mCAAmC;AACnC;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;AACjB;;AAEA,+BAA+B;AAC/B,YAAY;AACZ,uBAAuB;AACvB,IAAI;;AAEJ;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;QACV,yBAAyB;IAC7B,WAAW,cAAc,oBAAoB;IAC7C,kBAAkB;QACd,8BAA8B;AACtC;;AAEA,sBAAsB;AACtB;IACI,0CAA0C,GAAG,oCAAoC;IACjF,aAAa;IACb,kBAAkB;IAClB,wCAAwC;IACxC,WAAW;IACX,gBAAgB,GAAG,gCAAgC;IACnD,cAAc,GAAG,sCAAsC;AAC3D;;AAEA,wBAAwB;AACxB;IACI,uBAAuB;IACvB,aAAa;IACb,kBAAkB;AACtB;;AAEA,0BAA0B;AAC1B;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA,iBAAiB;AACjB;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,mCAAmC;AACnC;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;QACb,2CAA2C;IAC/C,WAAW,KAAK,sBAAsB;IACtC,sBAAsB,EAAE,2BAA2B;IACnD,kBAAkB;QACd,+BAA+B;QAC/B,aAAa;AACrB;;AAEA,sCAAsC;AACtC;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW,EAAE,sBAAsB;IACnC,iBAAiB;QACb,+BAA+B;QAC/B,mBAAmB;QACnB,uBAAuB;QACvB,gBAAgB;QAChB,gBAAgB;QAChB,sCAAsC;AAC9C;;AAEA,8BAA8B;AAC9B;IACI,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,wCAAwC;IACxC,WAAW;IACX,gBAAgB;IAChB,yBAAyB;AAC7B;;;AAGA,sBAAsB;AACtB,qCAAqC;AACrC;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,gBAAgB;IACpB;AACJ;;AAEA,gDAAgD;AAChD;IACI;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,gBAAgB;IACpB;AACJ;;AAEA,6BAA6B;AAC7B;IACI;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,gBAAgB;IACpB;AACJ;;AAEA,kCAAkC;AAClC;IACI;QACI,aAAa;QACb,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA,4BAA4B;AAC5B;IACI;QACI,aAAa;QACb,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;;QAEI,aAAa;QACb,eAAe;QACf,wBAAwB;IAC5B;AACJ;;AAEA,kCAAkC;AAClC;IACI;QACI,aAAa;QACb,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;QACnB,gBAAgB;QAChB,gBAAgB;IACpB;IACA;QACI,aAAa;QACb,gBAAgB;YACZ,mBAAmB;QACvB;;QAEA;YACI,mBAAmB;QACvB;;QAEA;;YAEI,aAAa;YACb,eAAe;YACf,wBAAwB;QAC5B;;QAEA;YACI,kBAAkB;YAClB,eAAe;QACnB;;QAEA;YACI,eAAe;QACnB;QACA;;QAEA,qCAAqC;QACrC;YACI;gBACI,YAAY;gBACZ,iBAAiB;YACrB;;YAEA;gBACI,iBAAiB;gBACjB,mBAAmB;gBACnB,gBAAgB;gBAChB,gBAAgB;YACpB;;YAEA;gBACI,aAAa;gBACb,gBAAgB;YACpB;;YAEA;gBACI,mBAAmB;YACvB;;YAEA;gBACI,eAAe;YACnB;;YAEA;;gBAEI,YAAY;gBACZ,eAAe;IAC3B;;IAEA;QACI,kBAAkB;YACd,eAAe;QACnB;;QAEA;YACI,eAAe;IACvB;AACJ","sourcesContent":["/* Wrapper for the video and content */\n.wrapper {\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n\n/* Video container styling */\n.oxy-video-container {\n    position: relative;\n}\n\n/* Video background styling */\nvideo {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    min-width: 100%;\n    min-height: 100%;\n    width: auto;\n    height: auto;\n    transform: translate(-50%, -50%);\n    z-index: -1;\n}\n\n/* Overlay on the video */\n.oxy-video-overlay {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background-color: rgba(0, 0, 0, 0.53);\n}\n\n\n/* Main container for the content */\n.maincontainer {\n    position: relative;\n    z-index: 1;\n    padding: 20px;\n}\n\n/* Header container with logo */\n/*#header {*/\n/*    padding: 20px 0;*/\n/*}*/\n\n.logo img {\n    max-width: 100%;\n}\n\n#dashboard-login {\n    display: block;\n        /* Simple block display */\n    width: 100%;             /* Take full width */\n    text-align: center;\n        /* Center align text content */\n}\n\n/* Login box styling */\n.login-box {\n    background-color: rgba(255, 255, 255, 0.8);  /* Slightly transparent background */\n    padding: 40px;\n    border-radius: 8px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    width: 100%;\n    max-width: 400px;  /* Max width for the login box */\n    margin: 0 auto;  /* Center the login box if necessary */\n}\n\n/* Login box container */\n.login-box {\n    background-color: white;\n    padding: 40px;\n    border-radius: 8px;\n}\n\n/* Form elements styling */\n.form-element {\n    margin-bottom: 20px;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n}\n\n.form-element label {\n    color: #333;\n    font-weight: 500;\n    text-align: left;\n    width: 100%;\n}\n\n.form-element input {\n    width: 100%;\n}\n\ninput[type='email'],\ninput[type='password'] {\n    width: 100%;\n    padding: 12px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n}\n\n/* Checkbox styling */\n.checkbox-holder {\n    display: flex;\n    align-items: center;\n}\n\n.input_checkbox {\n    margin-right: 10px;\n}\n\n.input_checkbox_label {\n    font-size: 14px;\n    color: #333;\n}\n\n/* Login button */\n.button.Login-btn {\n    background-color: #373C5F;\n    color: white;\n    padding: 15px 25px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    width: 100%;\n}\n\n.button.Login-btn:hover {\n    background-color: #373C5F;\n}\n\n/* Styling for the main container */\n.maincontainer {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 100vh;\n        /* Use min-height instead of fixed height */\n    width: 100%;    /* Ensure full width */\n    flex-direction: column; /* Stack items vertically */\n    position: relative;\n        /* Allow relative positioning */\n        padding: 20px;\n}\n\n/* Styling for the dashboard heading */\n.login-box-heading {\n    text-align: center;\n    color: #fff;\n    width: 100%; /* Ensure full width */\n    font-size: 2.5rem;\n        /* Use rem for better scaling */\n        margin-bottom: 30px;\n        /* Add proper spacing */\n        font-weight: 600;\n        margin-top: 60px;\n        /* Add top margin for better spacing */\n}\n\n/* Styling for the login box */\n.login-box {\n    background-color: white;\n    padding: 40px;\n    border-radius: 8px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    width: 100%;\n    max-width: 400px;\n    margin: 0 auto 200px auto;\n}\n\n\n/* Responsive styles */\n/* Large Desktop (1200px and above) */\n@media (min-width: 1200px) {\n    .maincontainer {\n        padding: 40px;\n    }\n\n    .login-box-heading {\n        font-size: 3rem;\n        margin-bottom: 40px;\n        margin-top: 80px;\n    }\n\n    .login-box {\n        padding: 50px;\n        max-width: 450px;\n    }\n}\n\n/* Desktop and Large Tablets (992px to 1199px) */\n@media (min-width: 992px) and (max-width: 1199px) {\n    .maincontainer {\n        padding: 30px;\n    }\n\n    .login-box-heading {\n        font-size: 2.8rem;\n        margin-bottom: 35px;\n        margin-top: 70px;\n    }\n\n    .login-box {\n        padding: 45px;\n        max-width: 420px;\n    }\n}\n\n/* Tablets (768px to 991px) */\n@media (min-width: 768px) and (max-width: 991px) {\n    .maincontainer {\n        padding: 25px;\n    }\n\n    .login-box-heading {\n        font-size: 2.5rem;\n        margin-bottom: 30px;\n        margin-top: 60px;\n    }\n\n    .login-box {\n        padding: 40px;\n        max-width: 400px;\n    }\n}\n\n/* Mobile Large (576px to 767px) */\n@media (min-width: 576px) and (max-width: 767px) {\n    .maincontainer {\n        padding: 20px;\n        min-height: 100vh;\n    }\n\n    .login-box-heading {\n        font-size: 2.2rem;\n        margin-bottom: 25px;\n        margin-top: 40px;\n    }\n\n    .login-box {\n        padding: 30px;\n        max-width: 350px;\n    }\n\n    .form-element {\n        margin-bottom: 18px;\n    }\n}\n\n/* Mobile (480px to 575px) */\n@media (min-width: 480px) and (max-width: 575px) {\n    .maincontainer {\n        padding: 15px;\n        min-height: 100vh;\n    }\n\n    .login-box-heading {\n        font-size: 1.9rem;\n        margin-bottom: 20px;\n        margin-top: 30px;\n    }\n\n    .login-box {\n        padding: 25px;\n        max-width: 320px;\n    }\n\n    .form-element {\n        margin-bottom: 16px;\n    }\n\n    input[type='email'],\n    input[type='password'] {\n        padding: 10px;\n        font-size: 16px;\n        /* Prevent zoom on iOS */\n    }\n}\n\n/* Small Mobile (320px to 479px) */\n@media (min-width: 320px) and (max-width: 479px) {\n    .maincontainer {\n        padding: 10px;\n        min-height: 100vh;\n    }\n\n    .login-box-heading {\n        font-size: 1.6rem;\n        margin-bottom: 15px;\n        margin-top: 20px;\n        line-height: 1.3;\n    }\n    .login-box {\n        padding: 20px;\n        max-width: 300px;\n            margin-bottom: 10px;\n        }\n        \n        .form-element {\n            margin-bottom: 15px;\n        }\n        \n        input[type='email'],\n        input[type='password'] {\n            padding: 10px;\n            font-size: 16px;\n            /* Prevent zoom on iOS */\n        }\n        \n        .button.Login-btn {\n            padding: 12px 20px;\n            font-size: 16px;\n        }\n        \n        .input_checkbox_label {\n            font-size: 13px;\n        }\n        }\n        \n        /* Extra Small Mobile (below 320px) */\n        @media (max-width: 319px) {\n            .maincontainer {\n                padding: 8px;\n                min-height: 100vh;\n            }\n        \n            .login-box-heading {\n                font-size: 1.4rem;\n                margin-bottom: 12px;\n                margin-top: 15px;\n                line-height: 1.2;\n            }\n        \n            .login-box {\n                padding: 15px;\n                max-width: 280px;\n            }\n        \n            .form-element {\n                margin-bottom: 12px;\n            }\n            \n            .form-element label {\n                font-size: 14px;\n            }\n        \n            input[type='email'],\n            input[type='password'] {\n                padding: 8px;\n                font-size: 16px;\n    }\n    \n    .button.Login-btn {\n        padding: 10px 15px;\n            font-size: 14px;\n        }\n        \n        .input_checkbox_label {\n            font-size: 12px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
